const map = {
	"./cin-node-logo.webp": 57014,
	"./eu.webp": 57345,
	"./inr-node-logo.webp": 339,
	"./jsc-node-logo.webp": 73648,
	"./logo-bioexcel-cv19.webp": 29826,
	"./logo-bioexcel.webp": 42018,
	"./logo-bsc.webp": 39981,
	"./logo-ebrains.webp": 72527,
	"./logo-hbp.webp": 22875,
	"./logo-irb.webp": 294,
	"./logo-mddb.webp": 42968,
	"./logo-mdposit.webp": 67817,
	"./logo-nostrum.webp": 19837,
	"./oxf-node-logo.webp": 79691,
	"./rpbs-node-logo.webp": 85875,
	"./ufl-node-logo.webp": 19269
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67723;